export default class PLAnalytics {
	initialize() {
		this.mentorListSearch();
		this.mentorListFilter();
		this.contactFormSubmitted();
	}

	mentorListSearch() {
		let timer = false;
		let previous_search = '';

		$('.mentor-search-card #search').on('keyup', function (e) {
			clearInterval(timer);

			// Trigger the event if user hasn't typed anything in 2 seconds
			timer = setTimeout(function () {
				// Get the value from the search
				let search_value = e.target.value;

				if (search_value != '' && search_value != previous_search) {
					previous_search = search_value;

					window.dataLayer = window.dataLayer || [];
					window.dataLayer.push({
						'event': 'mentor_list_search',
						'mentor_list_search_value': search_value,
					});
				}

			}, 2000);
		});
	}

	mentorListFilter() {
		Livewire.on('mentorListFilter', filter => {
			if (filter.filter && filter.value) {
				window.dataLayer = window.dataLayer || [];
				window.dataLayer.push({
					'event': 'mentor_list_filter',
					'mentor_list_filter_field': filter.filter,
					'mentor_list_filter_value': filter.value
				});
			}
		});
	}

	contactFormSubmitted() {
		Livewire.on('contactFormSubmitted', function(event) {
			window.dataLayer = window.dataLayer || [];
			window.dataLayer.push({
				'event': 'contact_form_submitted'
			});
		});
	}

} // end PLAnalytics